import { render, staticRenderFns } from "./PatientMedicationsCard.vue?vue&type=template&id=81ace834&scoped=true&"
import script from "./PatientMedicationsCard.vue?vue&type=script&lang=js&"
export * from "./PatientMedicationsCard.vue?vue&type=script&lang=js&"
import style0 from "./PatientMedicationsCard.vue?vue&type=style&index=0&id=81ace834&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ace834",
  null
  
)

export default component.exports